'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var Grid$1 = require('../../../node_modules/@material-ui/core/esm/Grid/Grid.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var Grid = React__default["default"].forwardRef(function (_ref, ref) {
  var container = _ref.container,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 0 : _ref$spacing,
      rest = objectWithoutProperties(_ref, ["container", "spacing"]);

  var getGridSpacing = function getGridSpacing(number) {
    if (number % 8 === 0 || number > 10) {
      return Math.floor(number / 8);
    }

    return number;
  };

  if (container) {
    return React__default["default"].createElement(Grid$1["default"], _objectSpread({
      container: true,
      spacing: getGridSpacing(spacing)
    }, rest, {
      ref: ref
    }));
  }

  return React__default["default"].createElement(Grid$1["default"], _objectSpread({}, rest, {
    ref: ref
  }));
});

module.exports = Grid;
